<template>
    <div class="">

        <div v-for="attribute in internalValue.form_attributes" v-if="internalValue && internalValue.form_attributes">

            <div class="form-multilang" :class="locale" v-if="attribute.has_languages" >
              <div v-for="lang in locales">
                  <form-text :lang="lang.id" :label="attribute.name" v-model="internalValue[attribute.slug][lang.id]" v-if="attribute.type == 'text'" :required="attribute.mandatory" v-show="lang.id == selectedLang || selectedLang == 'all'"></form-text>
                  <form-text :lang="lang.id" :label="attribute.name" v-model="internalValue[attribute.slug][lang.id]" v-if="attribute.type == 'email'" :required="attribute.mandatory" v-show="lang.id == selectedLang || selectedLang == 'all'"></form-text>
                  <form-phone :lang="lang.id" :label="attribute.name" v-model="internalValue[attribute.slug][lang.id]" v-if="attribute.type == 'phone'" :required="attribute.mandatory" v-show="lang.id == selectedLang || selectedLang == 'all'"></form-phone>
                  <form-textarea :lang="lang.id" :label="attribute.name" v-model="internalValue[attribute.slug][lang.id]" v-if="attribute.type == 'textarea'" :required="attribute.mandatory" v-show="lang.id == selectedLang || selectedLang == 'all'"></form-textarea>
                  <form-html :lang="lang.id" :label="attribute.name" v-model="internalValue[attribute.slug][lang.id]" v-if="attribute.type == 'html'" :required="attribute.mandatory" v-show="lang.id == selectedLang || selectedLang == 'all'"></form-html>
              </div>
            </div>

            <div v-if="!attribute.has_languages">
                <form-text :label="attribute.name" v-model="internalValue[attribute.slug]" v-if="attribute.type == 'text'" :required="attribute.mandatory"></form-text>
                <form-text :label="attribute.name" v-model="internalValue[attribute.slug]" v-if="attribute.type == 'email'" :required="attribute.mandatory"></form-text>
                <form-phone :label="attribute.name" v-model="internalValue[attribute.slug]" v-if="attribute.type == 'phone'" :required="attribute.mandatory"></form-phone>
                <form-textarea :label="attribute.name" v-model="internalValue[attribute.slug]" v-if="attribute.type == 'textarea'" :required="attribute.mandatory"></form-textarea>
                <form-html :label="attribute.name" v-model="internalValue[attribute.slug]" v-if="attribute.type == 'html'" :required="attribute.mandatory"></form-html>
                <form-date :label="attribute.name" v-model="internalValue[attribute.slug]" format="dd.mm.yyyy" v-if="attribute.type == 'date'" :required="attribute.mandatory"></form-date>
                <form-select :label="attribute.name" multiple="false" v-model="internalValue[attribute.slug]" id="id" :options="attribute.values" v-if="attribute.type == 'select'" :required="attribute.mandatory"></form-select>
                <form-select :label="attribute.name" multiple="false" v-model="internalValue[attribute.slug]" :default="attribute.country_id" :options="$store.state.countries" v-if="attribute.type == 'country'" :required="attribute.mandatory"></form-select>
                <form-color-picker :label="attribute.name" :color="internalValue[attribute.slug]" v-model="internalValue[attribute.slug]" v-if="attribute.type == 'color'" :required="attribute.mandatory"/>
                <form-file :label="attribute.name" v-model="internalValue[attribute.slug]" v-if="attribute.type == 'file'" :required="attribute.mandatory" width="200"></form-file>
                <form-toggle :label="attribute.name" v-model="internalValue[attribute.slug]" v-if="attribute.type == 'toggle'"></form-toggle>
            </div>

        </div>
    </div>
</template>

<script>

    export default {
        name: 'Attributes',
        props: ['value','locale'],
        data: function () {
            return {
                config: {

                },
                internalValue: [],
                locales: null,
                selectedLang: null,
                treated: false
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.selectedLang = this.locale
            this.locales = this.$store.state.scope.locales

        },
        methods: {
        },
        watch: {
            'locale'(newVal, oldVal) {
                this.selectedLang = newVal
            },
            'value'(newVal, oldVal) {
                this.internalValue = newVal

                if( !this.treated && this.internalValue && this.internalValue.form_attributes ){
                    for(let attribute of this.internalValue.form_attributes){
                        this.internalValue[attribute.slug] = attribute.value;
                    }
                    this.treated = true;
                }

            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Attributes.vue